import 'ui-core/widgets/publication-content/js/publication-content';
(function () {
    var altmetric = {
        holder: $('#doi_altmetric_drawer_area'),
        init: function () {
            altmetric.get.altmetric();
            altmetric.control();
        },
        control: function () {
            if (
                altmetric.holder.find('.altmetric-embed').length &&
                altmetric.holder.find('.altmetric-embed').html().length
            ) {
                altmetric.holder.show();
            } else {
                altmetric.holder.hide();
            }
            altmetric.holder.on('altmetric:show', () => {
                altmetric.control();
            });
        },
        get: {
            altmetric: function () {
                var script = document.createElement('script');
                const nonce = UX && UX.getRequestId ? UX.getRequestId() : null;
                script.type = 'text/javascript';
                if (script.nonce) script.nonce = nonce;
                script.src = window.location.protocol + '//d1bxh8uas1mnw7.cloudfront.net/assets/embed.js';
                document.getElementsByTagName('head')[0].appendChild(script);
            },
        },
    };
    UX.loader.mathJaxConfig = `MathJax.Hub.Config({
        preferredFont: "STIX",
        displayAlign: "center",
        "HTML-CSS": {scale: 200},
        styles: {
            '.math-formula *': {'font-size': '1rem'},
            '.inline-formula *': {'font-size': '1rem'},
            '.math-formula ': {'text-align': 'right'},
            '.math-formula .equationTd': {
                'display': 'block',
                'overflow-x': 'auto',
                'overflow-y': 'hidden',
                'text-align': 'center'
            }
        }
});`;
    UX.altmetric = altmetric;

    UX.loader.truncation.linesToShow = 3;
    UX.loader.truncation.showMoreText = $('article').data('view-all-author');
    UX.loader.truncation.showLessText = $('article').data('view-fewer-author');
    UX.loader.truncation.seeMoreIcon = 'icon-plus';
    UX.loader.truncation.seeLessIcon = 'icon-close';
    UX.loader.truncation.seeMoreIconMobile = 'icon-plus';

    if (document.getElementById('doi_altmetric_drawer_area')) {
        UX.altmetric.init();
    }
})();
